module.exports = __webpack_public_path__ + "img/img-trading-p3-3.08f21ae7.png";